import { Component, inject, Input, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { QrCodeModule } from 'ng-qrcode';
import { ModalController, ToastController } from '@ionic/angular/standalone';
import { RedeemType } from '../types';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { RippleModule } from 'primeng/ripple';
import { Clipboard } from '@capacitor/clipboard';

@Component({
  selector: 'app-share-dialog',
  template: `
    <div class="flex flex-col items-center justify-start w-full gap-1 mt-4 px-12">
      <qr-code #qrcodeElement [value]="generateUrl()" size="256" [errorCorrectionLevel]="'M'" id="qrcodeElement" />
      <p class="text-gray-800 text-base font-medium font-['Roboto'] leading-normal my-1 break-all">
        {{ extra }}
      </p>
      <div
        class="w-full border border-primary-200 rounded-md p-2  font-bold font-['Roboto'] leading-normal flex items-center justify-center gap-2"
        (click)="onCopyToClipboard()"
        pRipple>
        <p class="text-light-blue-500 text-base font-bold font-['Roboto'] leading-normal">{{ redeemCode }}</p>
        <button class="w-4 text-light-blue-500">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path
              d="M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
              fill="#058EF1" />
          </svg>
        </button>
      </div>
      <div
        class="w-full border border-primary-200 rounded-md p-2  font-bold font-['Roboto'] leading-normal flex items-center justify-center gap-2"
        (click)="onShare()"
        pRipple>
        <p class="text-light-blue-500 text-base font-bold font-['Roboto'] leading-normal">Share</p>
        <button class="w-4 ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22 6.28571C22 8.65179 20.0804 10.5714 17.7143 10.5714C16.4241 10.5714 15.2679 10 14.4821 9.09821L10.4777 11.1027C10.5402 11.3929 10.5714 11.692 10.5714 12C10.5714 12.308 10.5402 12.6071 10.4777 12.8973L14.4821 14.9018C15.2679 14 16.4241 13.4286 17.7143 13.4286C20.0804 13.4286 22 15.3482 22 17.7143C22 20.0804 20.0804 22 17.7143 22C15.3482 22 13.4286 20.0804 13.4286 17.7143C13.4286 17.4062 13.4598 17.1071 13.5223 16.817L9.51786 14.8125C8.73214 15.7143 7.57589 16.2857 6.28571 16.2857C3.91964 16.2857 2 14.3661 2 12C2 9.63393 3.91964 7.71429 6.28571 7.71429C7.57589 7.71429 8.73214 8.28571 9.51786 9.1875L13.5223 7.18304C13.4598 6.89286 13.4286 6.59375 13.4286 6.28571C13.4286 3.91964 15.3482 2 17.7143 2C20.0804 2 22 3.91964 22 6.28571ZM6.28571 14.1429C6.85404 14.1429 7.39908 13.9171 7.80094 13.5152C8.20281 13.1134 8.42857 12.5683 8.42857 12C8.42857 11.4317 8.20281 10.8866 7.80094 10.4848C7.39908 10.0829 6.85404 9.85714 6.28571 9.85714C5.71739 9.85714 5.17235 10.0829 4.77049 10.4848C4.36862 10.8866 4.14286 11.4317 4.14286 12C4.14286 12.5683 4.36862 13.1134 4.77049 13.5152C5.17235 13.9171 5.71739 14.1429 6.28571 14.1429ZM19.8571 6.28571C19.8571 6.00431 19.8017 5.72566 19.694 5.46568C19.5863 5.20569 19.4285 4.96947 19.2295 4.77049C19.0305 4.5715 18.7943 4.41366 18.5343 4.30597C18.2743 4.19828 17.9957 4.14286 17.7143 4.14286C17.4329 4.14286 17.1542 4.19828 16.8942 4.30597C16.6343 4.41366 16.398 4.5715 16.1991 4.77049C16.0001 4.96947 15.8422 5.20569 15.7345 5.46568C15.6269 5.72566 15.5714 6.00431 15.5714 6.28571C15.5714 6.56712 15.6269 6.84577 15.7345 7.10575C15.8422 7.36573 16.0001 7.60196 16.1991 7.80094C16.398 7.99993 16.6343 8.15777 16.8942 8.26546C17.1542 8.37315 17.4329 8.42857 17.7143 8.42857C17.9957 8.42857 18.2743 8.37315 18.5343 8.26546C18.7943 8.15777 19.0305 7.99993 19.2295 7.80094C19.4285 7.60196 19.5863 7.36573 19.694 7.10575C19.8017 6.84577 19.8571 6.56712 19.8571 6.28571ZM17.7143 19.8571C18.2826 19.8571 18.8277 19.6314 19.2295 19.2295C19.6314 18.8277 19.8571 18.2826 19.8571 17.7143C19.8571 17.146 19.6314 16.6009 19.2295 16.1991C18.8277 15.7972 18.2826 15.5714 17.7143 15.5714C17.146 15.5714 16.6009 15.7972 16.1991 16.1991C15.7972 16.6009 15.5714 17.146 15.5714 17.7143C15.5714 18.2826 15.7972 18.8277 16.1991 19.2295C16.6009 19.6314 17.146 19.8571 17.7143 19.8571Z"
              fill="#058EF1" />
          </svg>
        </button>
      </div>
    </div>
  `,
  standalone: true,
  imports: [QrCodeModule, RippleModule],
})
export class ShareDialogComponent {
  @Input() redeemCode!: string;
  @Input() redeemType!: RedeemType;
  @Input() extra!: string;

  modalCtrl = inject(ModalController);
  toastCtrl = inject(ToastController);

  isLoading = false;

  async onShare() {
    if (this.isLoading) return;
    this.isLoading = true;

    const message = this.generateMessage();

    try {
      if (Capacitor.isNativePlatform()) {
        await this.shareNative(message);
      } else {
        await this.shareWeb(message, this.generateUrl());
      }
    } catch (error) {
      console.error('Error sharing:', error);
      // Handle error (e.g., show a toast message)
    } finally {
      this.isLoading = false;
    }
  }

  private async shareNative(message: string) {
    const qrCodeBase64 = await this.convertQrCodeToBase64();
    const qrCodeFilePath = await this.saveBase64AsFile('qrcode.png', qrCodeBase64);

    await Share.share({
      title: 'Join to Chart Paper',
      text: message,
      url: this.generateUrl(),
      files: [qrCodeFilePath],
    });
  }

  private async shareWeb(message: string, url: string) {
    if (!navigator.share) {
      throw new Error('Web Share API not supported');
    }

    const shareData: ShareData = {
      title: 'Join to Chart Paper',
      text: message,
      url: url,
    };

    if (navigator.share) {
      try {
        const qrCodeBlob = await this.getQrCodeBlob();
        if (
          qrCodeBlob &&
          navigator.canShare &&
          navigator.canShare({ files: [new File([qrCodeBlob], 'qrcode.png', { type: 'image/png' })] })
        ) {
          shareData.files = [new File([qrCodeBlob], 'qrcode.png', { type: 'image/png' })];
        }
        await navigator.share(shareData);
      } catch (error) {
        console.error('Error in Web Share API:', error);
        throw error; // Re-throw to trigger fallback
      }
    } else {
      throw new Error('Web Share API not supported');
    }
  }

  private generateMessage(): string {
    switch (this.redeemType) {
      case 'Invite':
        return `You can join to our application using this Map Code: ${this.redeemCode}`;
      case 'UpStream':
        return `You can join to an Upstream Map using this Code: ${this.redeemCode}`;
      case 'JoinStream':
        return `You can join to a Child Stream Map using this Code: ${this.redeemCode}`;
      case 'SplitOffStream':
        return `You can transfer Stream using this Code: ${this.redeemCode}`;
      default:
        return `You can join to our application using this Group Code: ${this.redeemCode}`;
    }
  }

  private async getQrCodeBlob(): Promise<Blob | null> {
    const htmlElement = document.getElementById('qrcodeElement');
    const canvas = htmlElement?.lastElementChild as HTMLCanvasElement;
    if (!canvas) {
      console.error('QR Code canvas not found');
      return null;
    }

    return new Promise<Blob>((resolve, reject) => {
      canvas.toBlob((blob: Blob | null) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to convert QR Code to Blob'));
        }
      }, 'image/png');
    });
  }

  async onCopyToClipboard() {
    const modal = await this.modalCtrl.getTop();
    if (modal) await this.modalCtrl.dismiss();

    const writeToClipboard = async () => {
      await Clipboard.write({
        string: this.redeemCode,
      });
    };

    if (Capacitor.isNativePlatform()) {
      writeToClipboard();
    } else {
      navigator.clipboard.writeText(this.redeemCode);
    }

    const toast = await this.toastCtrl.create({
      message: 'Copied to clipboard!',
      duration: 2000,
    });
    await toast.present();
  }

  generateUrl = () => {
    const baseUrl = 'https://chartpaper.app';

    switch (this.redeemType) {
      case 'Invite':
        return `${baseUrl}/home/map/join-group?referralCode=${this.redeemCode}`;
      case 'UpStream':
        return `${baseUrl}/home/redeem?redeemCode=${this.redeemCode}`;
      case 'JoinStream':
        return `${baseUrl}/home/redeem?redeemCode=${this.redeemCode}`;
      case 'SplitOffStream':
        return `${baseUrl}/home/redeem?redeemCode=${this.redeemCode}`;
      default:
        return `${baseUrl}/home/redeem?redeemCode=${this.redeemCode}`;
    }
  };

  private async convertQrCodeToBase64(): Promise<string> {
    const htmlElement = document.getElementById('qrcodeElement');
    const canvas = htmlElement?.lastElementChild as HTMLCanvasElement;
    if (!canvas) {
      throw new Error('QR Code canvas not found');
    }

    return new Promise<string>((resolve, reject) => {
      try {
        const dataUrl = canvas.toDataURL('image/png');
        resolve(dataUrl);
      } catch (error) {
        reject(error);
      }
    });
  }

  private async saveBase64AsFile(fileName: string, base64: string): Promise<string> {
    const base64Data = base64.split(',')[1];

    const result = await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Cache,
    });

    return result.uri;
  }
}
